export const defaults = {
  __typename: 'profile',
};
